export const handleDateClass = (type, model, today) => {
  const date = model.date

  if (model.state_id == 7 && type == 'task') {
    return 'bg-theme-7'
  }

  if (model.state_id == 4 && type == 'task') {
    return 'bg-theme-1'
  }

  if (model.state_id == 6 && type == 'email') {
    return 'bg-theme-1'
  }

  if (date > today) {
    return 'bg-theme-9'
  }

  if (date == today) {
    return 'bg-theme-12'
  }

  return 'bg-theme-6'
}



// WEBPACK FOOTER //
// ./src/services/DateClass.js